
import { Component, Prop, Vue } from 'vue-property-decorator';
import { handleError, initClient } from '../../api';
import { DutyClient, TriggerCbmAnonymousDuty } from '../backend/backendapi';
import Toasted from "vue-toasted";

Vue.use(Toasted);

@Component({
  name: 'AnonymousDuty',
  components: {},
})
export default class AnonymousDuty extends Vue {
  private dutyApi = initClient(DutyClient);

  @Prop({ required: true })
  readonly cbmId!: string;

  email: string = '';
  comment: string = '';

  saved = false;

  async mounted(): Promise<void> {
  }

  async trigger(): Promise<void> {
    try {
      this.saved = true;
      await this.dutyApi.triggerCbmAnonymousDuty(new TriggerCbmAnonymousDuty({ cbmAnonymousId: this.cbmId, email: this.email, comment: this.comment }))
      this.$toasted.info(this.$t('duty.cbm.triggered').toString());
    } catch (e) {
      console.log(e)
      this.saved = false;
      handleError(this.$toasted, this.$i18n, e);
    }
  }
}
